"use client";

import { useEffect, useRef, useState } from "react";

export default function CountUp({
  value,
}: Readonly<{ value?: number | string }>) {
  const target = Number(value) || 0;
  const ref = useRef<HTMLSpanElement>(null);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStarted(true);
          observer.disconnect();
        }
      },
      { threshold: 0.4 },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <span
      ref={ref}
      className={`count-up${started ? " count-up-active" : ""}`}
      style={started ? { ["--num" as string]: target } : undefined}
      aria-label={String(target)}
    />
  );
}
